import { COAT_HANGER_BOX_OPENINGS } from '../utils/products.enums'
import { Size } from '../utils/Size'
import { PRODUCTS_LIST } from '../utils/products.list'
import { PrintingSettings } from '../utils/PrintingSettings'

export default class CoatHangerBoxFormModel {
  name = PRODUCTS_LIST.COAT_HANGER_BOX;

  constructor () {
    this.size = new Size({
      length: 50,
      depth: 50,
      height: 135
    })
    this.externalSize = true
    this.opening = COAT_HANGER_BOX_OPENINGS.TOP
    this.printing = new PrintingSettings()
    this.internalSupports = true
    this.amount = null
    this.additionalNotes = null
    this.email = null
  }
}
